export default __webpack_public_path__ + "static/blog-c509146f0c694e1a5eb294e2f70255a3.png";